<script lang="ts">
  import { onMount } from 'svelte';
  import type { ApiClient, TimeBounds } from '../lib/api';
  import { formatDate } from '../lib/format';
  import Loading from '../lib/Loading.svelte';
  import StatusBadge from '../lib/StatusBadge.svelte';
  import type { Incident } from '../lib/types';

  let { api }: { api: ApiClient } = $props();
  let incidents = $state<Incident[]>([]);
  let cursor = $state<string | null>(null);
  let loading = $state(true);
  let error = $state('');
  let status = $state('');
  let bounds = $state<TimeBounds | null>(null);

  async function load(next = '') {
    loading = true;
    try {
      const params = new URLSearchParams();
      if (status) params.set('status', status);
      if (next) params.set('cursor', next);
      if (next && bounds) {
        params.set('from', bounds.from);
        params.set('to', bounds.to);
      }
      const result = await api.incidents(`?${params}`);
      incidents = next ? [...incidents, ...result.items] : result.items;
      cursor = result.nextCursor;
      bounds = { from: result.from, to: result.to };
      error = '';
    } catch (reason) {
      error = reason instanceof Error ? reason.message : 'Incident history could not be loaded.';
    } finally {
      loading = false;
    }
  }

  onMount(() => load());
</script>

<section class="page-heading">
  <div><p class="eyebrow">Previous 30 days</p><h1>Incident history</h1><p>Newest alarm lifecycles across every customer.</p></div>
  <label>Status<select bind:value={status} onchange={() => load()}><option value="">All incidents</option><option value="open">Open</option><option value="resolved">Resolved</option></select></label>
</section>
{#if error}<p class="inline-error" role="alert">{error}</p>{/if}
{#if loading && incidents.length === 0}<Loading />
{:else if incidents.length === 0}<section class="empty"><h2>No incidents in this range</h2><p>Try a different status filter.</p></section>
{:else}
  <div class="table-wrap"><table class="history-table"><thead><tr><th>State</th><th>Customer</th><th class="alarm-column">Alarm</th><th>Opened</th><th>Last event</th></tr></thead><tbody>
    {#each incidents as incident}<tr><td><StatusBadge state={incident.status} /></td><td>{incident.customerName}</td><td class="alarm-column"><a class="alarm-name" href={`/incidents/${incident.id}`}>{incident.alarmName}</a><small class="alarm-context">{incident.accountName} · {incident.region}</small></td><td>{formatDate(incident.openedAt)}</td><td>{formatDate(incident.lastEventAt)}</td></tr>{/each}
  </tbody></table></div>
  {#if cursor}<button class="secondary load-more" disabled={loading} onclick={() => load(cursor ?? '')}>{loading ? 'Loading…' : 'Load more'}</button>{/if}
{/if}
